<template>
  <div>
    <div class="fotter2" v-if="$conFun.clientWidth() > 768">
      <div class="wd flex-sb" style="padding: 0 50px 20px 50px">
        <div class="f" style="margin-top: 40px">
          <div><span>公司名称：云学科技（北京）有限公司</span></div>
          <div>地址：北京市朝阳区广渠路17号院1号楼联美大厦</div>
        </div>
        <div class="flex-sb">
          <div style="text-align:center;padding-right:80px">
            <img
              src="http://h5.shihua.com/static/yunxue/app.png"
              style="width: 109px; height: 109px; "
              @click="dialogVisible1 = true"
            />
            <div>关注云学公众号</div>
          </div>
           <div style="text-align:center">
            <img
              src="http://h5.shihua.com/static/yunxue/gzh.png"
              style="width: 109px; height: 109px"
              @click="dialogVisible2 = true"
            />
            <div>下载云学APP</div>
          </div>
        </div>
      </div>
      <div
        class="wd flex-sb"
        style="padding-bottom: 10px; align-items: flex-end"
      >
        <div>
          <img src="@/assets/images/1/logo_blue.png" style="width: 140px" />
        </div>
        <div style="font-size: 25px">13167586989</div>
      </div>
      <div
        class="wd flex-sb"
        style="border-top: 1px solid #fff; padding-top: 10px"
      >
        <div>
          <div>京公网安备 11010502047251号 京ICP备19027979号-2</div>
          <div>Copyright 2023 云学, All Rights Reserved</div>
        </div>
        <div>联系电话</div>
      </div>
      <el-dialog :visible.sync="dialogVisible1" width="500px">
        <img
          src="http://h5.shihua.com/static/yunxue/app.png"
          style="width: 400px; height: 400px; margin: 0 0 0 20px"
        />
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible2" width="500px">
        <img
          src="http://h5.shihua.com/static/yunxue/gzh.png"
          style="width: 400px; height: 400px; margin: 0 0 0 20px"
        />
      </el-dialog>
    </div>

    <div
      class="fotter2"
      v-else
      style="padding: 15px 0; line-height: 16px; font-size: 11px"
    >
      <div class="f" style="text-align: center">
        <div><span>公司名称：世华企业管理集团有限公司</span></div>
        <div><span>联系电话：86390819</span></div>
        <div>地址：北京市平谷区马昌营镇天井大街甲2号</div>
        <div>备案号：京ICP备19027981号-2</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Fotter.vue